// ============================================================================
// CECODEV Platform - Main App Component
// ============================================================================

import { useEffect } from "react";
import { captureAttributionFromUrl } from "./lib/attribution";
import ScrollRestauration from "./components/ScrollRestauration";
import { Routes, Route } from "react-router-dom";
import { Box, Typography } from "@mui/material";
import { Toaster } from "sonner";
import { AuthProvider } from "./contexts/AuthContext";
import { OrganisationProvider } from "./contexts/OrganisationContext";
import { PermissionsProvider } from "./hooks/usePermissions";
import { ConfirmProvider } from "./hooks/useConfirm";

// Compteur d'usage des pages (détection de code mort — CONSOLIDATION P5)
import PageUsageTracker from "./components/PageUsageTracker";

// Page d'accueil (chargée immédiatement) ; toutes les autres pages vivent dans routes/.
import LandingPage from "./pages/LandingPage";
import { routesPubliques } from "./routes/publiques";
import { routesPilotage } from "./routes/pilotage";
import { routesAdminPlateforme } from "./routes/admin-plateforme";
import { routesEspacePerso } from "./routes/espace-perso";
import { routesHistoriques } from "./routes/historiques";

function App() {
  // Attribution marketing (UTM/referrer/landing) : capture first-touch au
  // chargement — AVANT toute campagne, sinon les données sont perdues.
  useEffect(() => {
    captureAttributionFromUrl();
  }, []);
  return (
    <AuthProvider>
      <OrganisationProvider>
        <PermissionsProvider>
        <ConfirmProvider>
        <Box
          sx={{
            minHeight: "100vh",
            backgroundColor: "background.default",
          }}
        >
        <ScrollRestauration />
        <PageUsageTracker />
        <Routes>
          {/* Lot 7.6 : les <Route> vivent dans src/routes/, un fichier par domaine,
              rendus ici dans l'ordre d'origine (zéro URL changée). Les routes
              d'une page s'ajoutent dans le fichier de son domaine. */}
          {routesPubliques()}
          {routesPilotage()}
          {routesAdminPlateforme()}
          {routesEspacePerso()}
          {routesHistoriques()}

          {/* Landing page — redirige vers dashboard si connecté */}
          <Route path="/" element={<LandingPage />} />
          
          {/* 404 */}
          <Route
            path="*"
            element={
              <Box sx={{ p: 4 }}>
                <Typography variant="h5">Page non trouvée</Typography>
              </Box>
            }
          />
        </Routes>
        
        <Toaster position="top-right" />
      </Box>
        </ConfirmProvider>
      </PermissionsProvider>
      </OrganisationProvider>
    </AuthProvider>
  );
}

export default App;

